import { boot } from 'quasar/wrappers';
import axios, { AxiosInstance } from 'axios';
import dotenv from 'dotenv';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance;
  }
}

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)

const VITE_API_URL = typeof process !== 'undefined' && !import.meta.env ? process.env.VITE_API_URL : import.meta.env.VITE_API_URL;

const api = axios.create({ baseURL: VITE_API_URL });

export default boot(({ app, ssrContext }) => {
  // SSR modunda header'ları al ve axios'a öntanımlı olarak ekle
  if (ssrContext && ssrContext.req) {
    const headers = {
      'X-Real-IP': ssrContext.req.headers['x-real-ip'] || ssrContext.req.connection.remoteAddress,
      'X-Forwarded-For': ssrContext.req.headers['x-forwarded-for'],
      'X-Forwarded-Proto': ssrContext.req.headers['x-forwarded-proto'],
      'User-Agent': ssrContext.req.headers['user-agent'],
      Accept: ssrContext.req.headers['accept'],
      Referer: ssrContext.req.headers['referer'],
      // Eklemek istediğiniz diğer header'lar
    };

    // Öntanımlı header'ları api istemcisine ekle
    api.defaults.headers.common = {
      ...api.defaults.headers.common,
      ...headers,
    };
  }

  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios;
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api;
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
});

export { api };
